export class AdditionalInfo {
  constructor(
    public name: string,
    public title: string,
    public icon: string
  ) {}
}
